import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { TasksOverviewComponent } from './tasks-overview/components/tasks-overview/tasks-overview.component';
import { AccessDeniedComponent } from './security/components/access-denied/access-denied.component';
import { PreviewSearchComponent } from './tasks-overview/components/preview-search/preview-search.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'tasks-overview',
  },

  {
    path: 'tasks-overview',
    component: TasksOverviewComponent,
  },
  {
    path: 'copyright-and-title',
    loadChildren: () =>
      import('./copyright-and-title/copyright-and-title.module').then(
        (m) => m.CopyrightAndTitleModule,
      ),
  },
  {
    path: 'canadian-common-law',
    loadChildren: () =>
      import('./canadian-common-law/canadian-common-law.module').then(
        (m) => m.CanadianCommonLawModule,
      ),
  },
  {
    path: 'results-overview',
    loadChildren: () =>
      import('./results/results.module').then((m) => m.ResultsModule),
  },
  {
    path: 'web-common-law',
    loadChildren: () =>
      import('./web-common-law/web-common-law.module').then(
        (m) => m.WebCommonLawModule,
      ),
  },
  {
    path: 'access-denied',
    pathMatch: 'full',
    component: AccessDeniedComponent,
  },
  {
    path: 'task/:taskId/preview-search/:prodOrderNo/:prodOrderSeqNo',
    pathMatch: 'full',
    component: PreviewSearchComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
